import { useEffect } from "react";
export const useKeyboardHandler = (config) => {
    const { isActive, onEscape, onZoomIn, onZoomOut, onResetZoom, preventDefault = true } = config;
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (!isActive)
                return;
            switch (event.key) {
                case "Escape":
                    if (onEscape) {
                        if (preventDefault)
                            event.preventDefault();
                        onEscape();
                    }
                    break;
                case "=":
                case "+":
                    if (onZoomIn) {
                        if (preventDefault)
                            event.preventDefault();
                        onZoomIn();
                    }
                    break;
                case "-":
                    if (onZoomOut) {
                        if (preventDefault)
                            event.preventDefault();
                        onZoomOut();
                    }
                    break;
                case "0":
                    if (onResetZoom) {
                        if (preventDefault)
                            event.preventDefault();
                        onResetZoom();
                    }
                    break;
            }
        };
        if (isActive) {
            document.addEventListener("keydown", handleKeyDown);
        }
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [isActive, onEscape, onZoomIn, onZoomOut, onResetZoom, preventDefault]);
};
//# sourceMappingURL=useKeyboardHandler.js.map